import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore"
import { getStorage } from "firebase/storage"

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: "e2df24yfc.firebaseapp.com",
  projectId: "e2df24yfc",
  storageBucket: "e2df24yfc.appspot.com",
  messagingSenderId: "1061871320200",
  appId: "1:1061871320200:web:7424664cb4848e1b3f333d"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth()
export const db = getFirestore()
export const storage = getStorage()